<script>
    import simplebar from "simplebar-vue";
    import { layoutComputed } from "@/state/helpers";

    /**
     * Horizontal-topbar component
     */
    export default {
        props: {
            type: {
                type: String,
                required: true
            },
            width: {
                type: String,
                required: true
            }
        },
        computed: {
            ...layoutComputed
        },
        components: {
            simplebar
        },
        data() {
            return {
                efpList: [],
                selectedEfp: null,
                userName: null
            };
        },
        watch: {
            selectedEfp(efp) {
                if (!efp) return;
                localStorage.setItem("selected-efp-type", efp.type);
                localStorage.setItem("selected-efp-code", efp.code);
                localStorage.setItem("selected-efp", efp.id);
                this.mitt.emit("efp-changed", efp.id);
            }
        },
        methods: {
            toggleRightSidebar() {
                this.$parent.toggleRightSidebar();
            },
            toggleMenu() {
                let element = document.getElementById("topnav-menu-content");
                element.classList.toggle("show");
            },
            initFullScreen() {
                document.body.classList.toggle("fullscreen-enable");
                if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                    // current working methods
                    if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen();
                    } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                    } else if (document.documentElement.webkitRequestFullscreen) {
                        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                    }
                } else {
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    }
                }
            },
            async fillDropdowns() {
                const userId = this.$store.state.authfack.user.id;
                const efpList = await this.$axios.get(`/users/${userId}/efp`);
                this.efpList = efpList;
                let efp = localStorage.getItem("selected-efp-code");
                efp = efpList.map(group => group.items).find(item => item.code == efp) || efpList[0]?.items[0];
                this.selectedEfp = efp;
            }
        },
        mounted() {
            const user = this.$store.state.authfack.user;
            this.userName = user.nom;

            this.fillDropdowns();
        }
    };
</script>

<template>
    <header id="page-topbar">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box">
                    <router-link to="/" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="@/assets/images/ofppt-logo.png" alt height="22" />
                        </span>
                        <span class="logo-lg">
                            <img src="@/assets/images/ofppt-logo.png" alt height="17" />
                        </span>
                    </router-link>

                    <router-link to="/" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="@/assets/images/ofppt-logo.png" alt height="22" />
                        </span>
                        <span class="logo-lg">
                            <img src="@/assets/images/ofppt-logo.png" alt height="70" style="background: #fff; padding: 6px" />
                        </span>
                    </router-link>
                </div>
                <button id="toggle" type="button" class="btn btn-sm mr-2 font-size-16 d-lg-none header-item" @click="toggleMenu">
                    <i class="fa fa-fw fa-bars"></i>
                </button>

                <!-- App Search-->
                <!-- <form class="app-search d-none d-lg-block">
                    <div class="position-relative">
                        <input type="text" class="form-control" placeholder="Rechercher" />
                        <span class="bx bx-search-alt"></span>
                    </div>
                </form> -->

                <b-dropdown right variant="black" toggle-class="header-item">
                    <template v-slot:button-content>
                        <div class="d-flex align-items-center">
                            <div class="avatar-xs d-xl-inline-block">
                                <span class="avatar-title rounded-circle bg-soft bg-white text-primary font-size-14" v-if="userName">{{ userName.slice(0, 1) }}</span>
                            </div>
                            <span class="d-none d-xl-inline-block mx-2 text-left">
                                <span class="d-block">{{ userName }}</span>
                                <small class="d-block" v-if="selectedEfp">{{ selectedEfp.fonction }}</small>
                            </span>
                            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                        </div>
                    </template>
                    <!-- item-->
                     <b-dropdown-item @click="$router.push('/profile')">
                        <i class="bx bx-user font-size-16 align-middle mr-1"></i>
                        Mon profil
                     </b-dropdown-item>
                    <!-- <b-dropdown-item class="d-block" href="javascript: void(0);">
                        <i class="bx bx-wrench font-size-16 align-middle mr-1"></i>
                        Réglages
                    </b-dropdown-item>
                    <b-dropdown-item href="javascript: void(0);">
                        <i class="bx bx-lock-open font-size-16 align-middle mr-1"></i>
                        Écran verrouillé
                    </b-dropdown-item> -->
                    <b-dropdown-divider></b-dropdown-divider>
                    <a href="/logout" class="dropdown-item text-danger">
                        <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                        Se déconnecter
                    </a>
                </b-dropdown>
            </div>

            <div class="d-flex">
                <div class="dropdown ml-1 mr-3 d-flex align-items-center">
                    <dropdown v-model="selectedEfp" :options="efpList" dark :allow-empty="false" placeholder="EFP" track-by="code" group-values="items" group-label="group" style="width: 450px" />
                </div>

                <!-- <div class="dropdown ml-1 mr-3 d-flex align-items-center">
                    <dropdown v-model="selectedYear" :options="yearsList" dark :allow-empty="false" placeholder="Année scolaire" style="width: 160px" />
                </div> -->

                <!-- <b-dropdown right menu-class="dropdown-menu-lg p-0" toggle-class="header-item noti-icon" variant="black">
                    <template v-slot:button-content>
                        <i class="bx bx-bell bx-tada"></i>
                        <span class="badge badge-danger badge-pill">{{ $t("navbar.dropdown.notification.badge") }}</span>
                    </template>

                    <div class="p-3">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="m-0">
                                    {{ $t("navbar.dropdown.notification.text") }}
                                </h6>
                            </div>
                            <div class="col-auto">
                                <a href="#" class="small">{{ $t("navbar.dropdown.notification.subtext") }}</a>
                            </div>
                        </div>
                    </div>
                    <simplebar style="max-height: 230px">
                        <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media">
                                <div class="avatar-xs mr-3">
                                    <span class="avatar-title bg-primary rounded-circle font-size-16">
                                        <i class="bx bx-cart"></i>
                                    </span>
                                </div>
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">
                                        {{ $t("navbar.dropdown.notification.order.title") }}
                                    </h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">
                                            {{ $t("navbar.dropdown.notification.order.text") }}
                                        </p>
                                        <p class="mb-0">
                                            <i class="mdi mdi-clock-outline"></i>
                                            {{ $t("navbar.dropdown.notification.order.time") }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media">
                                <img src="@/assets/images/users/avatar-3.jpg" class="mr-3 rounded-circle avatar-xs" alt="user-pic" />
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">
                                        {{ $t("navbar.dropdown.notification.james.title") }}
                                    </h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">
                                            {{ $t("navbar.dropdown.notification.james.text") }}
                                        </p>
                                        <p class="mb-0">
                                            <i class="mdi mdi-clock-outline"></i>
                                            {{ $t("navbar.dropdown.notification.james.time") }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media">
                                <div class="avatar-xs mr-3">
                                    <span class="avatar-title bg-success rounded-circle font-size-16">
                                        <i class="bx bx-badge-check"></i>
                                    </span>
                                </div>
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">
                                        {{ $t("navbar.dropdown.notification.item.title") }}
                                    </h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">
                                            {{ $t("navbar.dropdown.notification.item.text") }}
                                        </p>
                                        <p class="mb-0">
                                            <i class="mdi mdi-clock-outline"></i>
                                            {{ $t("navbar.dropdown.notification.item.time") }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a href="javascript: void(0);" class="text-reset notification-item">
                            <div class="media">
                                <img src="@/assets/images/users/avatar-4.jpg" class="mr-3 rounded-circle avatar-xs" alt="user-pic" />
                                <div class="media-body">
                                    <h6 class="mt-0 mb-1">
                                        {{ $t("navbar.dropdown.notification.salena.title") }}
                                    </h6>
                                    <div class="font-size-12 text-muted">
                                        <p class="mb-1">
                                            {{ $t("navbar.dropdown.notification.salena.text") }}
                                        </p>
                                        <p class="mb-0">
                                            <i class="mdi mdi-clock-outline"></i>
                                            {{ $t("navbar.dropdown.notification.salena.time") }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </simplebar>
                    <div class="p-2 border-top">
                        <a class="btn btn-sm btn-light btn-block text-center" href="javascript:void(0)">
                            <i class="mdi mdi-arrow-down-circle mr-1"></i>
                            {{ $t("navbar.dropdown.notification.button") }}
                        </a>
                    </div>
                </b-dropdown> -->

                <div class="dropdown d-none d-lg-inline-block ml-1">
                    <button type="button" class="btn header-item noti-icon" @click="initFullScreen">
                        <i class="bx bx-fullscreen"></i>
                    </button>
                </div>

                <!-- <div class="dropdown d-inline-block">
                    <button type="button" class="btn header-item noti-icon right-bar-toggle toggle-right" @click="toggleRightSidebar">
                        <i class="bx bx-cog bx-spin toggle-right"></i>
                    </button>
                </div> -->
            </div>
        </div>
    </header>
</template>
